var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9943 18.0006C35.9943 27.0918 29.2574 34.6076 20.5056 35.8272C19.6873 35.9407 18.85 36 18.0002 36C17.0192 36 16.0559 35.9218 15.1178 35.7705C6.54887 34.3906 0.00488281 26.9593 0.00488281 18.0006C0.00488281 8.05942 8.06193 0 17.999 0C27.936 0 35.9943 8.05942 35.9943 18.0006Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5056 14.4528V18.374H25.355L24.5871 23.6562H20.5056V35.826C19.6873 35.9395 18.8501 35.9988 18.0002 35.9988C17.0193 35.9988 16.056 35.9206 15.1179 35.7693V23.6562H10.6455V18.374H15.1179V13.5762C15.1179 10.5996 17.5299 8.18561 20.5069 8.18561V8.18813C20.5157 8.18813 20.5233 8.18561 20.5321 8.18561H25.3562V12.7539H22.204C21.2672 12.7539 20.5069 13.5144 20.5069 14.4515L20.5056 14.4528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3901d94194acee087edbc6a90a2afd43.svg";
export { ForwardRef as ReactComponent };